var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseRed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Essentional, UI / Close "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23483 2.23483C2.38128 2.08839 2.61872 2.08839 2.76517 2.23483L6.00001 5.46968L9.23484 2.23486C9.38128 2.08842 9.61872 2.08842 9.76517 2.23486C9.91161 2.38131 9.91161 2.61875 9.76517 2.76519L6.53034 6.00001L9.76514 9.23481C9.91158 9.38125 9.91158 9.61869 9.76514 9.76514C9.61869 9.91158 9.38125 9.91158 9.23481 9.76514L6.00001 6.53034L2.76519 9.76516C2.61875 9.91161 2.38131 9.91161 2.23486 9.76516C2.08842 9.61872 2.08842 9.38128 2.23486 9.23483L5.46968 6.00001L2.23483 2.76517C2.08839 2.61872 2.08839 2.38128 2.23483 2.23483Z",
    fill: "#EF4444"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseRed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close_red.0ace00a49244a99d9681a64b9648727c.svg";